import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { getLabel } from '@shared/utils';
import {
    Box,
    Chip,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    useTheme,
} from '@mui/material';
import { getCorrespondentTypes } from '@shared/services/api/correspondentService';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name) ? theme.typography.fontWeightMedium : theme.typography.fontWeightRegular,
  };
}

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const CorrespondentSelector = ({ onChange, defaultValue, validate }) => {
  const theme = useTheme();
  const [listData, setListData] = useState([]);
  const [value, setValue] = useState([]);

  if (defaultValue && defaultValue.length > 0 && value.length === 0) {
    setValue(defaultValue);
  }

  useEffect(() => {
    const fetchData = async () => {
      let { data } = (await getCorrespondentTypes()) || {};
      setListData(data || []);
    };
    fetchData();
  }, []);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setValue(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    );
    onChange(typeof value === 'string' ? value.split(',') : value);
  };

  const getNameById = (id) => {
    const dataFound = listData.find((data) => data.id === id);
    return dataFound?.description ?? '';
  };
  return (
    <FormControl error={validate ? value.length === 0 : false}>
      <InputLabel id="multiple-corresponsal-label">Tipo de Corresponsal</InputLabel>
      <Select
        labelId="multiple-corresponsal-label"
        multiple
        defaultValue={defaultValue}
        value={value}
        onChange={handleChange}
        errors={''}
        placeholder="Seleccione corresponsales"
        input={<OutlinedInput id="select-multiple-corresponsal" label="Tipo de Corresponsal" />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value} label={getNameById(value)} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}>
        {listData.map(({ id, description }) => (
          <MenuItem key={id} value={id} style={getStyles(description, value, theme)}>
            {description}
          </MenuItem>
        ))}
      </Select>
      {validate && value.length === 0 && (
        <FormHelperText sx={{ color: '#d32f2f' }}>{getLabel('roleManagementSelectError')}</FormHelperText>
      )}
    </FormControl>
  );
};

CorrespondentSelector.propTypes = {
  onChange: PropTypes.func,
  defaultValue: PropTypes.array,
  validate: PropTypes.bool,
};

export default CorrespondentSelector;
